import React from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import {
  StandaloneTask,
  StandaloneTaskResponse,
  TaskStandAloneAlarm,
} from "shared/api";
import { useTaskHubState } from "shared/hooks/useTaskHubState";
import { AddTaskModalStandAlone } from "./AddTaskForStandAlone";
import { StandaloneTaskChart } from "./StandaloneTaskChart";
import { EditTaskModalStandAlone } from "./EditTaskModalStandAlone";
import { EditTaskStandAloneAlarmModal } from "./EditTaskStandAloneAlarmModal";

interface TaskHubStandaloneProps {
  // main standalone tasks data
  standAloneData: StandaloneTaskResponse | undefined;
  loadingStandAlone: boolean;

  // pagination
  currentPage: number;
  pageSize: number;
  setCurrentPage: (page: number) => void;
  setPageSize: (size: number) => void;

  // standalone task table columns
  columnsStandAlone: ColumnsType<StandaloneTask>;

  // alarm tasks data
  tasksAlarmStandAlone: TaskStandAloneAlarm[] | undefined;
  columnsStandAloneSecondTable: ColumnsType<TaskStandAloneAlarm>;
  tasksAlarmStandAloneRefetch: () => void;

  // все модальные состояния одним объектом
  modalState: ReturnType<typeof useTaskHubState>;
}

export const TaskHubStandalone: React.FC<TaskHubStandaloneProps> = ({
  standAloneData,
  loadingStandAlone,
  currentPage,
  pageSize,
  setCurrentPage,
  setPageSize,
  columnsStandAlone,
  tasksAlarmStandAlone,
  columnsStandAloneSecondTable,
  tasksAlarmStandAloneRefetch,
  modalState,
}) => {
  return (
    <>
      {/* Standalone tasks table */}
      <Table<StandaloneTask>
        dataSource={standAloneData?.results || []}
        columns={columnsStandAlone}
        rowKey="id"
        loading={loadingStandAlone}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50"],
          current: currentPage,
          pageSize,
          total: standAloneData?.count || 0,
          showSizeChanger: true,
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
        onRow={(record: StandaloneTask) => ({
          onClick: () => {
            modalState.setSelectedTaskId(record.id);
            modalState.setIsChartOpen(true);
          },
        })}
        scroll={{ x: true }}
      />

      {/* Add standalone task modal */}
      <AddTaskModalStandAlone
        open={modalState.isAddModalStandAloneOpen}
        onClose={() => modalState.setIsAddModalStandAloneOpen(false)}
      />

      {/* Standalone task chart */}
      <StandaloneTaskChart
        taskId={modalState.selectedTaskId}
        open={modalState.isChartOpen}
        onClose={() => modalState.setIsChartOpen(false)}
      />

      {/* Edit standalone task modal */}
      <EditTaskModalStandAlone
        open={modalState.isEditStandAloneOpen}
        onClose={() => {
          modalState.setIsEditStandAloneOpen(false);
          modalState.setEditingStandAloneId(null);
        }}
        taskId={modalState.editingStandAloneId}
      />

      {/* Alarm tasks table */}
      <Table<TaskStandAloneAlarm>
        dataSource={tasksAlarmStandAlone || []}
        columns={columnsStandAloneSecondTable}
        rowKey="id"
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50"],
          current: currentPage,
          pageSize,
          total: tasksAlarmStandAlone?.length ?? 0,
          showSizeChanger: true,
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
      />

      {/* Edit standalone alarm modal */}
      <EditTaskStandAloneAlarmModal
        open={modalState.isEditAlarmOpen}
        onClose={() => {
          modalState.setIsEditAlarmOpen(false);
          modalState.setEditingAlarm(null);
        }}
        record={modalState.editingAlarm}
        refetch={tasksAlarmStandAloneRefetch}
      />
    </>
  );
};
